import { ApiServiceDictionaryItem } from '/react4xp/parts/admin-api-call-statistics/types';
import {
    DEFAULT_SORT_FIELD,
    SORT_FIELDS,
} from './constants';
import { CallStatisticsSortState } from './types';

export const sanitizeTaxpayerCode = (value?: string): string =>
    (value || '').replace(/\D/g, '').slice(0, 12);

export const buildApiNamesMap = (
    dictionary: ApiServiceDictionaryItem[]
): Record<string, string> =>
    dictionary.reduce<Record<string, string>>((result, item) => {
        result[item.code] = item.name;
        return result;
    }, {});

export const getSortParam = (sort: CallStatisticsSortState): string => {
    const backendField = SORT_FIELDS[sort.field] || SORT_FIELDS[DEFAULT_SORT_FIELD];
    const direction = sort.order === 'ascend' ? 'asc' : 'desc';

    return `${backendField},${direction}`;
};

export const getRequestErrorKey = (error: any): string => {
    if (!error?.response) {
        return 'admin-api-stat-error-network';
    }

    if (error.response.status === 400) {
        return 'admin-api-stat-error-bad-request';
    }

    if (error.response.status === 403) {
        return 'admin-api-stat-error-forbidden';
    }

    if (error.response.status === 500) {
        return 'admin-api-stat-error-server';
    }

    return 'admin-api-stat-error-generic';
};